import AdmissionChecklistTemplate from "../../features/pendingSignOffs/templates/AdmissionChecklistTemplate";

export default function AdmissionChecklistScreen() {
  return <AdmissionChecklistTemplate />;
}
